// Copyright (c) 2015, NSQUARE Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

// for translation
froggy._ = function (txt, replace, context = null) {
	if (!txt) return txt;
	if (typeof txt != "string") return txt;

	let translated_text = "";

	let key = txt; // txt.replace(/\n/g, "");
	if (context) {
		translated_text = froggy._messages[`${key}:${context}`];
	}

	if (!translated_text) {
		translated_text = froggy._messages[key] || txt;
	}

	if (replace && typeof replace === "object") {
		translated_text = $.format(translated_text, replace);
	}
	return translated_text;
};

window.__ = froggy._;

froggy.get_languages = function () {
	if (!froggy.languages) {
		froggy.languages = [];
		$.each(froggy.boot.lang_dict, function (lang, value) {
			froggy.languages.push({ label: lang, value: value });
		});
		froggy.languages = froggy.languages.sort(function (a, b) {
			return a.value < b.value ? -1 : 1;
		});
	}
	return froggy.languages;
};
